import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import queryClient from '../query-client';
import { WorksheetChecklistItemStatusEnum } from '../types/worksheet-checklist-item';

type UpdateChecklistItemStatusRequest = {
    checklistItemId: string;
    status: WorksheetChecklistItemStatusEnum;
    notApplicableReason?: string;
};

async function updateChecklistItemStatus(workpaperId: string, worksheetId: string, req: UpdateChecklistItemStatusRequest): Promise<void> {
    const { data } = await api.patch(`/workpapers/${workpaperId}/worksheets/${worksheetId}/checklist/${req.checklistItemId}`, {
        status: req.status,
        notApplicableReason: req.notApplicableReason,
    });
    return data;
}

export function useUpdateChecklistItemStatus(
    worksheetId: string
): UseMutationResult<void, unknown, UpdateChecklistItemStatusRequest, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useMutation((req) => updateChecklistItemStatus(workpaperId, worksheetId, req), {
        onSettled: () => {
            queryClient.invalidateQueries(['checklist', worksheetId]);
            queryClient.invalidateQueries(['worksheets', worksheetId]);
            queryClient.invalidateQueries(['worksheets', workpaperId]);
            queryClient.invalidateQueries([workpaperId, 'trial-balance']);
            queryClient.invalidateQueries(['history']);
        },
    });
}
